import { NeiVariable } from './nei-card.component'
import { twMerge } from 'src/utils/tw-merge.util'
import List from '../list/list.component'
import { useTranslation } from 'react-i18next'
import { ArrowTriangleIcon, CurecallModalContainer } from '@honestica/curecall-ui'
import { useState } from 'react'

interface NeiModalProps {
  isOpen: boolean
  onToggle: () => void
  neiVariables?: NeiVariable[]
}

const NeiModal = ({ isOpen, neiVariables, onToggle }: NeiModalProps) => {
  const { t } = useTranslation()
  const [openItems, setOpenItems] = useState<Set<number>>(new Set())

  const toggleItem = (index: number) => {
    const newOpenItems = new Set(openItems)
    if (newOpenItems.has(index)) {
      newOpenItems.delete(index)
    } else {
      newOpenItems.add(index)
    }
    setOpenItems(newOpenItems)
  }

  return (
    <CurecallModalContainer
      title={t('components.patient.patient-file.body.followup-details.nei-title')}
      isOpen={isOpen}
      toggle={onToggle}
      dialogClassName="c-w-2/3 c-relative"
    >
      {neiVariables ? (
        <div className="c-space-y-7">
          {neiVariables.map((neiVariable, index) => {
            const isOpen = openItems.has(index)
            return (
              <div key={neiVariable.label}>
                <button
                  onClick={() => toggleItem(index)}
                  className={twMerge(
                    'c-rounded-full c-w-full c-px-7 c-py-4 c-flex c-shadow-md c-items-center c-justify-between c-font-bold c-text-base c-bg-[#F4F5F8] hover:c-bg-opacity-20 hover:c-shadow-lg c-border c-border-grey-200 hover:c-border-grey-600',
                  )}
                >
                  <div className="c-flex c-gap-5 c-items-center c-justify-evenly">
                    <span>{index < 9 ? `0${index + 1}` : index + 1}</span>
                    <span>{neiVariable.label}</span>
                    {neiVariable.value}
                  </div>
                  <div className="c-flex c-items-center c-gap-3">
                    <span className="c-text-muted">
                      {isOpen
                        ? t('components.patient.patient-file.body.followup-details.hidde')
                        : t('components.patient.patient-file.body.followup-details.show')}
                    </span>
                    <ArrowTriangleIcon position={isOpen ? 'DOWN' : 'UP'} className="tw-w-4 tw-text-primary" />
                    <div className={isOpen ? `arrow-right arrow-toggle` : `arrow-right`} />
                  </div>
                </button>
                {isOpen && (
                  <div className="c-px-8 c-pt-4">
                    <List list={neiVariable.nonScoringVariables} className="c-font-normal" />
                  </div>
                )}
              </div>
            )
          })}
        </div>
      ) : (
        <div className="text-muted">
          {t('components.patient.patient-file.body.followup-details.form-sent-but-not-filled-yet')}
        </div>
      )}
    </CurecallModalContainer>
  )
}

export default NeiModal
